import { UserTypeEnum } from '@jooxter/api';

export type TAdapterOptions = {
  title?: 'organizer' | 'resource' | 'summary';
  editable?: boolean;
  // The viewer's type: a plain user cannot move the start of a booking in progress.
  userType?: UserTypeEnum;
};

export interface Adapter<T, K> {
  adapt: (input: T, options?: TAdapterOptions) => K;
  revert: (output: K) => T;
}

export enum EventTypeEnum {
  BOOKING = 'BOOKING',
  EXCEPTIONAL_OPENING_HOURS = 'EXCEPTIONAL_OPENING_HOURS',
  FAKE = 'FAKE',
}
